import { FC, useState } from "react";
import {
  AdditionalPrice,
  InlineNote,
  PriceNoteText,
  VerticalDivider,
} from "src/molecules/ProductInfo/ProductInfo.styled";
import { Trans } from "@lingui/macro";
import { Price } from "src/atoms/Price";
import { useTheme, Theme } from "@emotion/react";
import InfoItalicSmall from "src/icons/InfoItalicSmall";
import { PriceInfoWrapper, Button, NoteWrapper } from "./PriceInfo.styled";
import { Text } from "@otrium/atoms";
import { Flex } from "@otrium/core";
import { InfoItalic } from "src/icons";

interface Props {
  lowestPrice?: number | null;
}

const InfoButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const theme: Theme = useTheme();
  return (
    <Button onClick={onClick} data-testid="product-info-price-info-button">
      <InfoItalicSmall color={theme.colors.tone.black} />
    </Button>
  );
};

const PriceInfo: FC<Props> = ({ lowestPrice }) => {
  const theme: Theme = useTheme();
  const [isMessageVisible, setIsMessageVisible] = useState(false);

  return (
    <PriceInfoWrapper>
      <InlineNote>
        <PriceNoteText>
          {"*"}
          <Trans>price_info.rrp</Trans>
        </PriceNoteText>
        {lowestPrice && (
          <>
            {" "}
            <VerticalDivider />{" "}
            <PriceNoteText>
              <Trans>PP</Trans>
            </PriceNoteText>{" "}
            <AdditionalPrice
              data-testid="product-info-lowest-price"
              strike={true}
            >
              <Price price={lowestPrice} />
            </AdditionalPrice>{" "}
            <InfoButton
              onClick={() => {
                setIsMessageVisible((isVisible) => !isVisible);
              }}
            />
          </>
        )}
      </InlineNote>
      {isMessageVisible && (
        <NoteWrapper my={3}>
          <Flex variant="centered" mr={2} height={"24px"} minWidth={"24px"}>
            <InfoItalic color={theme.colors.tone.black} />
          </Flex>
          <Text
            color="Black"
            fontSize={0}
            lineHeight={1.43}
            fontWeight="normal"
          >
            <Trans>price_info.pp</Trans>
          </Text>
        </NoteWrapper>
      )}
    </PriceInfoWrapper>
  );
};

export default PriceInfo;
